import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";

import { LoginPageRoutingModule } from "./login-routing.module";
import { LoginPage } from "./login.page";
import { ComponentsModule } from "src/app/components/components.module";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { Mask } from "src/app/components/mask";
import { BrMaskerModule } from 'br-mask';
import { TagsService } from "src/app/services/tags/tags.service";
import { DesignSystemModule } from "src/theme/design-system/design-system.module";
import { PipesModule } from "../../../pipes/pipes.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoginPageRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    BrMaskerModule,
    DesignSystemModule,
    PipesModule
  ],
  providers: [AppVersion, TagsService],
  declarations: [LoginPage, Mask],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class LoginPageModule { }
